import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ImportService } from '@app/modules/import/services/import/import.service';
import { ImportType, ImportTypeMap } from '@app/modules/import/types/import.types';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';

type LauncherStyle = 'BUTTON' | 'TILE';

@Component({
    standalone: true,
    selector: 'app-import-launcher',
    templateUrl: './import-launcher.template.html',
    imports: [PlatformModule, TranslateModule, CommonModule],
    styleUrls: ['./import-launcher.style.scss'],
})
export class ImportLauncherComponent {
    @Input() launcherStyle: LauncherStyle = 'BUTTON';
    @Input() labelLength: 'LONG' | 'SHORT' = 'SHORT';
    isImportDialogOpen = false;
    availableImportTypes: ImportType[] = [];
    isLoading = true;
    IMPORT_CONFIGS: ImportTypeMap;

    constructor(public importService: ImportService) {
        this.setAvailableImportTypes();
        this.IMPORT_CONFIGS = importService.IMPORT_CONFIGS;
    }

    handleClick(type: ImportType, $event: Event): void {
        this.importService.handleImportTypeSelected(type, $event);
    }

    get hasMultipleImportFlows(): boolean {
        return this.availableImportTypes.length > 1;
    }

    private async setAvailableImportTypes(): Promise<void> {
        this.availableImportTypes = await this.importService.getAvailableImportTypes();
        this.isLoading = false;
    }
}
